import { StateWatcher } from './lib/state-watcher';
import { utils } from '../../../modules/core';
import config from '../../../global/env.config';
const { version, commitSha } = config;
export default class AbstractTrack {
    constructor($injector) {
        this.$injector = $injector;
        this.customTrackData = {};
        this.$rootScope = $injector.get('$rootScope');
        this.$ngRedux = $injector.get('$ngRedux');
        this.trackingFactory = $injector.get('trackingFactory');
        this.stateWatcher = StateWatcher.getInstance(this.$injector);
        this.commonContext = {
            commit_sha: commitSha,
            frontend_version: version,
            is_apollo: false,
            service: 'doxyme-frontend',
        };
    }
    trackSegment(customTrackData, skipSegmentTrackData = false, context) {
        if (!this.eventNameSegment) {
            throw new Error('Segment analytics tracker: event name not specified');
        }
        const eventName = this.eventNameSegment;
        const segmentTrackData = this.stateWatcher.getSegmentTrackData();
        if (this.FOR_DOMAINS_ONLY &&
            !this.FOR_DOMAINS_ONLY.includes(segmentTrackData.domain)) {
            return;
        }
        const data = utils.camelToSnakeCaseObject({
            ...(skipSegmentTrackData ? {} : segmentTrackData),
            ...customTrackData,
            ...this.commonContext,
        });
        this.trackingFactory.global.track(eventName, data, context);
    }
    trackButtonEventSegment(btnProperties) {
        if (!this.eventNameSegment) {
            throw new Error('Segment analytics tracker: event name not specified');
        }
        const eventName = this.eventNameSegment;
        this.trackingFactory.global.trackButtonClick({
            button_text: eventName,
            ...this.commonContext,
            ...btnProperties,
        });
    }
}
